<template>
  <div class="indexer mb-1">
    <drop-down
      class="mb-1"
      id="drop-down-resolver-drop-down"
      :label="`${widgetConfig.label}:`"
      v-model="selectedItem"
      :items="items"
    />
    <div class="d-flex">
      <button class="btn btn-primary" type="button" @click="resolveClicked">
        Resolve
      </button>
    </div>
  </div>
</template>
<script>
import graph from "@/services/sharedo/graphService";

const loadItems = async function () {
  const response = await graph.getDropDownItems(this.widgetConfig.apiPath);
  this.items = response.map((item) => ({
    label: item.name,
    value: item.systemName,
  }));

  if (this.items.length > 0) {
    this.selectedItem = this.items[0].value;
  }
};

const resolveClicked = function () {
  this.$emit("resolve", this.selectedItem, "index");
};

export default {
  props: {
    field: {
      required: true,
    },
  },
  data: function () {
    return {
      items: [],
      selectedItem: "",
    };
  },
  computed: {
    widgetConfig: function () {
      return this.field.value.indexer.widgetConfig;
    },
  },
  methods: {
    resolveClicked,
  },
  emits: ["resolve"],
  mounted: loadItems,
};
</script>